import { render, staticRenderFns } from "./MyprofileOutputCard.vue?vue&type=template&id=7f08a342&scoped=true"
import script from "./MyprofileOutputCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyprofileOutputCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyprofileOutputCard.vue?vue&type=style&index=0&id=7f08a342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f08a342",
  null
  
)

export default component.exports